export default __webpack_public_path__ + "static/planificateur-sante-bb51ef9b536618d16f42e02a8b7b1c32.png";